import {Link, withRouter} from 'react-router-dom'
import Cookies from 'js-cookie'
import {FaHome, FaBriefcase, FaSignOutAlt} from 'react-icons/fa'

import './index.css'

const Header = props => {
  const onClickLogout = () => {
    const {history} = props
    console.log(props)
    console.log(history)
    Cookies.remove('jwt_token')
    history.push('/login')
  }
  return (
    <>
      <nav className="nav-cont desktop-nav-cont">
        <Link to="/">
          <img
            src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
            alt="website logo"
            className="logo"
          />
        </Link>
        <div>
          <Link to="/" className="link-item">
            Home
          </Link>
          <Link to="/jobs" className="link-item">
            Jobs
          </Link>
        </div>
        <button className="logout-btn" type="button" onClick={onClickLogout}>
          Logout
        </button>
      </nav>
      <nav className="nav-cont mobile-nav-cont">
        <Link to="/">
          <img
            src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
            alt="website logo"
            className="logo"
          />
        </Link>
        <div className="mobile-nav-link-items-cont">
          <Link to="/" className="link-item">
            <FaHome />
          </Link>
          <Link to="/jobs" className="link-item">
            <FaBriefcase />
          </Link>
          <button
            className="mobile-logout-btn"
            type="button"
            onClick={onClickLogout}
          >
            <FaSignOutAlt />
          </button>
        </div>
      </nav>
    </>
  )
}

export default withRouter(Header)
